import React from 'react';
import { Shield, Droplets, Leaf } from 'lucide-react';
import { SectionHeader } from '../ui/Shared';
export function SolutionSection() {
  const pillars = [{
    icon: <Droplets className="w-6 h-6 text-accent" data-id="element-308" />,
    title: 'Mecanismo del Agua Tibia',
    desc: 'Activa la producción natural de bicarbonato de sodio en tu propio cuerpo.'
  }, {
    icon: <Leaf className="w-6 h-6 text-accent" data-id="element-309" />,
    title: 'Ciclo de Sábila de 20 Días',
    desc: 'Crea un "cemento biológico" que sella y regenera las paredes de tu estómago.'
  }, {
    icon: <Shield className="w-6 h-6 text-accent" data-id="element-310" />,
    title: 'Desinflamación Natural',
    desc: 'Permite que la hernia hiatal se desinflame y el fuego se extinga de forma natural.'
  }];
  return <section id="solucion" className="py-24 bg-surface" data-id="element-311">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-312">
        <SectionHeader tag="El mecanismo único" title={<>
              El Protocolo de Hidratación
              <br data-id="element-314" />
              de Protección Mucosa (HPM)
            </>} subtitle="Aprenderás a activar el 'Mecanismo del Agua Tibia' para que tu propio cuerpo produzca el bicarbonato de sodio que necesita para defenderse." data-id="element-313" />

        <div className="scale-in bg-gradient-to-br from-surface-2 to-accent/5 border border-accent/25 rounded-2xl p-8 md:p-12 mt-10 relative overflow-hidden" data-id="element-315">
          {/* Decorative circle */}
          <div className="absolute top-0 right-0 w-48 h-48 bg-[radial-gradient(circle,rgba(232,160,32,0.1),transparent)] rounded-full" data-id="element-316" />

          <div className="relative z-10" data-id="element-317">
            <h3 className="font-playfair text-2xl md:text-3xl text-accent mb-6 font-bold" data-id="element-318">
              Cómo funciona el escudo biológico
            </h3>

            <div className="space-y-6" data-id="element-319">
              {pillars.map((pillar, idx) => <div key={idx} className="flex gap-5 items-start" data-id="element-320">
                  <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center shrink-0 border border-accent/20" data-id="element-321">
                    {pillar.icon}
                  </div>
                  <div data-id="element-322">
                    <h4 className="text-lg font-bold text-text-light mb-1" data-id="element-323">
                      {pillar.title}
                    </h4>
                    <p className="text-text-muted leading-relaxed" data-id="element-324">
                      {pillar.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}